import(/* webpackMode: "eager" */ "/app/apps/provider-app/app/error.tsx");
